import { Component, OnInit } from '@angular/core';
import { AddFamilyDetailsDialogComponent } from '../add-family-details-dialog/add-family-details-dialog.component';
import { startWith,map } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { OutingApprovalApiService } from '../outing-approval-api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { OutingApiService } from '../outing-api.service';
import { OutingObservableService } from '../outing-observable.service';

@Component({
  selector: 'app-single-outing-request',
  templateUrl: './single-outing-request.component.html',
  styleUrls: ['./single-outing-request.component.scss']
})
export class SingleOutingRequestComponent implements OnInit {

  reasonFilter: any = new FormControl("");
  selectedReason: any = "reason"
  reasons: any = []
  reasonList: any[] = []
  inTime: string | null = null;
  outTime: string | null = null;

  // Example min/max limits
  minDateTime: any;
  maxDateTime: any;
  studentGrievanceText: any = ""
  maxChar: number = 1000;
  filteredreasons: any;
  familyDetailsList: any;
  image: any = "image"
  familyImages: any;
  profile: any;
  familyDetails: any;
  selected: any;
  selectedItems: any;
  selectedItem: any;

  constructor(private dialog: MatDialog, private spinner: NgxSpinnerService, private observable: OutingObservableService, private outingservice: OutingApiService, private sanitizer: DomSanitizer, private router: Router) {
    const now = new Date();
    this.minDateTime = this.formatDateTimeLocal(now);
    const nextYear = new Date(now);
    nextYear.setFullYear(now.getFullYear() + 1);
    this.maxDateTime = this.formatDateTimeLocal(nextYear);
  }

  private formatDateTimeLocal(date: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : n);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }


  ngOnInit(): void {
    this.profile = JSON.parse(localStorage.getItem("profile") || "{}");
    this.getFamilyDetials()
    this.getFamilyReasons()

  }

  getFamilyDetials() {
    this.spinner.show()
    this.outingservice.getFamilyDetails().subscribe({
      next: (res: any) => {
        if (!res) {
          this.familyDetailsList = [];
          this.spinner.hide()
          return;
        }

        this.familyDetailsList = res;
        this.familyImages = {};
        const uniqueRefId = localStorage.getItem("uniqueRefId");

        for (let i = 0; i < this.familyDetailsList.length; i++) {
          const relationKey = this.familyDetailsList[i].relationName;
          this.getFamilyPhoto(this.familyDetailsList[i].familyId, uniqueRefId)
            .subscribe((blob: any) => {
              if (!blob) return;
              const url = URL.createObjectURL(blob);
              this.familyImages[relationKey] = this.sanitizer.bypassSecurityTrustUrl(url);
            });
        }
        this.spinner.hide()
      },
      error: (err: any) => {
        this.spinner.hide()
        console.error(err)
      }
    });
  }


  getFamilyPhoto(familyId: any, admNo: any): any {
    return this.outingservice.getFamilyPhoto(admNo, familyId);
  }



  getFamilyReasons() {
    this.spinner.show()
    this.outingservice.getOutingReasons().subscribe({
      next: (res: any) => {
        if (!res || res.length === 0) {
          this.spinner.hide()
          console.warn('No outing reasons found.');
          this.reasonList = [];
          return;
        }

        this.reasonList = res;

        // Reactive filtering
        this.filteredreasons = this.reasonFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) =>
            this.Filter(value, this.reasonList, 'reason')
          )
        );
        this.spinner.hide()
      },
      error: (err:any) => {
        console.error('Error fetching outing reasons:', err);
        this.reasonList = [];
        this.spinner.hide()
      }
    });
  }

  private Filter(value: string, list: any[], name: any): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].toString().trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }

  addNewMember() {
    this.dialog.open(AddFamilyDetailsDialogComponent, {
      width: '450px',
      height: '500px',
      maxHeight: '70vh',
    });
  }

  toggle(item: any) {
    if (this.selectedItem === item.relationName) {
      this.selectedItem = null;
      this.familyDetails = null
    } else {
      this.selectedItem = item.relationName;
      this.familyDetails = item
    }
  }

  submitOutingRequest() {
    this.spinner.show()
    const uniqueRefId = localStorage.getItem("uniqueRefId");
    const payload = {
      "admNo": uniqueRefId,
      "familyId": this.familyDetails.familyId,
      "outingDate": this.outTime,
      "returnDate": this.inTime,
      "reasonId": this.selectedReason.reasonId,
      "outingStatus": "REQUESTED",
      "outingType": "SINGLE"
    }
    this.outingservice.saveStudentOutingDetails(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide()
        this.observable.setSubmissionData(res)
        this.router.navigate(['/Outing/requestSubmission']);
      },
      error: (err: any) => {
        this.spinner.hide()
      }
    })
  }

}
